import Styles from "./Styles.module.scss";
import { IndonesiaGlobe, mapicon } from "../../assets/png";
import groupmap from "../../assets/png/OurCompany/groupMap.png";
import iconTitleLocation from "../../assets/png/frame-title-location.png";
import closeIcon from "../../assets/png/close.png";
import { useNav } from "../../Hooks/useNav";
import { ArrowForward, Mail } from "@mui/icons-material";
import MdPhone from "@mui/icons-material/Phone";
import { useEffect, useMemo, useState } from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Modal from "../../components/Modal";
const Countries = [
  {
    id: "01",
    name: "Aceh",
  },
  {
    id: "02",
    name: "Medan",
  },
  {
    id: "03",
    name: "Padang",
  },
  {
    id: "015",
    name: "Pekanbaru",
  },
  {
    id: "04",
    name: "Batam",
  },
  {
    id: "05",
    name: "Palembang",
  },
  {
    id: "06",
    name: "Lampung",
  },
  {
    id: "07",
    name: "Jakarta",
  },
  {
    id: "08",
    name: "Bandung",
  },
  {
    id: "09",
    name: "Semarang",
  },
  {
    id: "010",
    name: "Surabaya",
  },
  {
    id: "011",
    name: "Bali",
  },
  {
    id: "012",
    name: "Banjarmasin",
  },
  {
    id: "013",
    name: "Makassar",
  },
  {
    id: "014",
    name: "Manado",
  },
];

export default function Benefit() {
  const aboutRef = useNav("About Us");
  const [isShowTooltip, setIsShowTooltip] = useState(false);
  const handleOpenGMaps = (address) => {
    window.open(`https://www.google.com/maps/place/${address}`, "_blank");
  };
  const [isShowModal, setIsShowModal] = useState(false);
  const [showAnotherBranch, setShowAnotherBranch] = useState(0);

  const permataBranches = useMemo(() => {
    return [
      {
        id: 1,
        name: "Aceh",
        branches: ["Branch Office"],
        address: [
          "Jalan Angsa no.1, Desa Batoh, Kecamatan Lueng Bata, Kota Banda Aceh. Kode Pos : 23245",
        ],
        phone: ["0651 - 7315783"],
        email: "info@pemataindonesia.com",
        right: "96.8%",
        top: "1.4%",
      },
      {
        id: 2,
        name: "Medan",
        branches: ["Branch Office"],
        address: [
          "Jl. Nenas No.4c, Silalas, Kec. Medan Bar., Kota Medan, Sumatera Utara 20234",
        ],
        phone: ["061-4573367"],
        email: "info@pemataindonesia.com",
        right: "93.2%",
        top: "4.5%",
      },
      {
        id: 3,
        name: "Padang",
        branches: ["Branch Office"],
        address: [
          "48GW+9GH, Jl. Prof. Dr. Hamka, Parupuk Tabing, Kec. Koto Tangah, Kota Padang, Sumatera Barat 25586",
        ],
        phone: ["0751 - 8972602"],
        email: "info@pemataindonesia.com",
        right: "91.2%",
        top: "19.5%",
      },
      {
        id: 4,
        name: "Pekanbaru",
        branches: ["Branch Office"],
        address: [
          "Jl. Kutilang No.27B, Kp. Melayu, Kec. Sukajadi, Kota Pekanbaru, Riau 28122",
        ],
        phone: ["0761 - 7874395"],
        email: "info@pemataindonesia.com",
        right: "86.2%",
        top: "17.5%",
      },
      {
        id: 5,
        name: "Batam",
        branches: ["Branch Office"],
        address: [
          "43G2+8JM, Jl. Ahmad Yani, Tlk. Tering, Kec. Batam Kota, Kota Batam, Kepulauan Riau 29444",
        ],
        phone: ["0778 - 469875"],
        email: "info@pemataindonesia.com",
        right: "82%",
        top: "24.5%",
      },
      {
        id: "hidden-1",
        name: "",
        isHidden: true,
        branches: [""],
        address: [""],
        phone: "",
        email: "",
        right: "84.4%",
        top: "26%",
      },
      {
        id: "hidden-2",
        name: "",
        isHidden: true,
        branches: [""],
        address: [""],
        phone: "",
        email: "",
        right: "84.7%",
        top: "43.5%",
      },
      {
        id: "palembang",
        name: "Palembang",
        branches: ["Branch Office"],
        address: [
          "JL. URIP SUMOHARJO LK I NO 166/23 RT/RW 003/000, KEC. WAYHALIM, KEL. GUNUNGSULAH KOTA. BANDAR LAMPUNG, KODE POS 35136",
        ],
        phone: ["0711 - 7443465"],
        email: "info@pemataindonesia.com",
        right: "79.8%",
        top: "42.4%",
      },
      {
        id: 7,
        name: "Lampung",
        branches: ["Branch Office"],
        address: [
          "JL. URIP SUMOHARJO LK I NO 166/23 RT/RW 003/000, KEC. WAYHALIM, KEL. GUNUNGSULAH KOTA. BANDAR LAMPUNG, KODE POS 35136",
        ],
        phone: ["0711 - 7443465"],
        email: "info@pemataindonesia.com",
        right: "80%",
        top: "58%",
      },
      {
        id: 8,
        name: "Jakarta",
        branches: ["Head Office 1", "Head Office 2", "Head Office 3"],
        address: [
          "Jl. Kyai Maja No.7a, RT.4/RW.1, Grogol Sel., Kec. Kby. Baru, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12130",
          "Jl. Raya Kby. Lama No.225, RT.10/RW.1, Grogol Sel., Kec. Kby. Lama, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12220",
          "Jalan Cidodol Raya No. 40, Kebayoran Baru, Jakarta Selatan, Kode Pos 12220, Indonesia",
        ],
        phone: ["021 726 5364 (Hunting)", "021 727 86574 (Fax)"],
        email: "info@pemataindonesia.com",
        right: "77.7%",
        top: "64.5%",
      },
      {
        id: 9,
        name: "Bandung",
        branches: ["Branch Office"],
        address: [
          "Jl. Buah Batu No.232B, Cijagra, Kec. Lengkong, Kota Bandung, Jawa Barat 40264",
        ],
        phone: ["0222 730 4533"],
        email: "info@pemataindonesia.com",
        right: "73.5%",
        top: "68.6%",
      },
      {
        id: 10,
        name: "Semarang",
        branches: ["Branch Office"],
        address: [
          "Jl. Pleburan Barat No.7 D, Pleburan, Kec. Semarang Sel., Kota Semarang, Jawa Tengah 50241",
        ],
        phone: ["024 845 6279"],
        email: "info@pemataindonesia.com",
        right: "69.5%",
        top: "68.6%",
      },
      {
        id: 11,
        name: "Surabaya",
        branches: ["Branch Office"],
        address: [
          "Gedung Permata Indonesia, Jl. Kayoon No.26F, Embong Kaliasin, Kec. Genteng, Surabaya, Jawa Timur 60271",
        ],
        phone: ["031 5467541"],
        email: "info@pemataindonesia.com",
        right: "65.7%",
        top: "72.3%",
      },
      {
        id: 12,
        name: "Surabaya",
        branches: ["Branch Office"],
        address: [
          "Gedung Permata Indonesia, Jl. Kayoon No.26F, Embong Kaliasin, Kec. Genteng, Surabaya, Jawa Timur 60271",
        ],
        phone: ["031 5467541"],
        email: "info@pemataindonesia.com",
        right: "65.7%",
        top: "72.3%",
      },
      {
        id: 13,
        name: "Bali",
        branches: ["Branch Office"],
        address: [
          "Kompleks Pertokoan Sudirman Agung, C-49, Bali, Dauh Puri Klod, Denpasar Barat, Denpasar City, Bali 80113",
        ],
        phone: ["0361 241 687"],
        email: "info@pemataindonesia.com",
        right: "62%",
        top: "73.6%",
      },
      {
        id: 14,
        name: "Banjarmasin",
        branches: ["Branch Office"],
        address: [
          "70235, Jl. Karang Paci No.2, Karang Mekar, Kec. Banjarmasin Tim., Kota Banjarmasin, Kalimantan Selatan 70237",
        ],
        phone: ["0511-674 3316"],
        email: "info@pemataindonesia.com",
        right: "61%",
        top: "50.3%",
      },

      {
        id: 15,
        name: "Makassar",
        branches: ["Branch Office"],
        address: [
          "Kompleks Ruko Pasar Segar, Jl. Pengayoman Blok RD 5, Pandang, Kec. Panakkukang, Kota Makassar, Sulawesi Selatan 90231",
        ],
        phone: ["0651 - 7315783"],
        email: "info@pemataindonesia.com",
        right: "50%",
        top: "60%",
      },
      {
        id: 16,
        name: "Manado",
        branches: ["Branch Office"],
        address: [
          "Jalan Angsa no.1, Desa Batoh, Kecamatan Lueng Bata, Kota Banda Aceh. Kode Pos : 23245",
        ],
        phone: ["0411 - 433103"],
        email: "info@pemataindonesia.com",
        right: "44%",
        top: "35%",
      },
    ];
  }, []);

  useEffect(() => {
    if (!isShowModal || !isShowTooltip) {
      setShowAnotherBranch(0);
    }
  }, [isShowModal, isShowTooltip]);

  const TooltipContent = ({ b }) => {
    return (
      <div
        key={b.id}
        className={`${Styles.pointBranch}  ${b.isHidden && Styles.erase}`}
        style={{
          right: b.right,
          top: b.top,
          height: b.id === "hidden-2" ? "24px" : "",
          width: b.id === "hidden-2" ? "24px" : "",
        }}
        onMouseEnter={() => (b.isHidden ? {} : setIsShowTooltip(b.id))}
        onMouseLeave={() => setIsShowTooltip(false)}
        onMouseUp={() => (b.isHidden ? {} : setIsShowTooltip(b.id))}
      >
        {b.id === isShowTooltip && <div className={Styles.keepHovering} />}
        <span className={Styles.pointed} />
        {b.id === isShowTooltip && (
          <div className={`${Styles.wrapTooltip}  `}>
            <span className={Styles.popover} />
            <section className={Styles.tooltipContain}>
              <section className={Styles.header}>
                <div>
                  <img src={iconTitleLocation} alt="icon" />
                  <h5>Detail Lokasi</h5>
                </div>
                <img
                  src={closeIcon}
                  onClick={() => setIsShowTooltip(false)}
                  alt="close-icon"
                />
              </section>
              <div className={Styles.locationName}>
                <h5>{b.name}</h5>
                <span className={Styles.branch}>
                  {b.branches[showAnotherBranch]}
                </span>
                <div className={Styles.divider} />

                <div className={Styles.address}>
                  <div className={Styles.name}>
                    <img src={iconTitleLocation} alt="icon" />
                    <span
                      className={Styles.linkAddress}
                      onClick={() =>
                        handleOpenGMaps(b.address[showAnotherBranch])
                      }
                    >
                      {b.address[showAnotherBranch]}
                    </span>
                  </div>
                  <div className={Styles.name}>
                    <MdPhone sx={{ color: "#6C757D" }} />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span className={Styles.values}>{b.phone[0]}</span>
                      <span className={Styles.values}>{b.phone[1]}</span>
                    </div>
                  </div>
                  <div className={Styles.name}>
                    <Mail sx={{ color: "#6C757D" }} />
                    <span className={Styles.values}>{b.email}</span>
                  </div>
                </div>
                {b.branches.length > 1 && (
                  <div className={Styles.buttonIcons}>
                    <div
                      onClick={() =>
                        showAnotherBranch === 0
                          ? {}
                          : setShowAnotherBranch(showAnotherBranch - 1)
                      }
                      className={Styles[showAnotherBranch !== 0]}
                    >
                      <ChevronLeft fontSize="24px" />
                    </div>
                    <div
                      onClick={() =>
                        showAnotherBranch === b.branches.length - 1
                          ? {}
                          : setShowAnotherBranch(showAnotherBranch + 1)
                      }
                      className={
                        Styles[showAnotherBranch === b.branches.length - 1]
                      }
                    >
                      <ChevronRight fontSize="24px" />
                    </div>
                  </div>
                )}
              </div>
            </section>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <Modal isOpen={isShowModal} onClose={() => setIsShowModal(false)}>
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "300px",
          }}
        >
          {permataBranches
            .filter((el) => el.name === isShowModal)
            ?.map((b) => (
              <div
                key={b.id}
                className={`${Styles.pointBranch} ${
                  b.isHidden && Styles.erase
                }`}
                style={{
                  right: "98%",
                  top: "100%",
                  width: "0",
                  display: "flex",
                }}
              >
                <div className={Styles.wrapTooltip}>
                  <section className={Styles.tooltipContain}>
                    <section className={Styles.header}>
                      <div>
                        <img src={iconTitleLocation} alt="icon" />
                        <h5>Detail Lokasi</h5>
                      </div>
                      <img
                        src={closeIcon}
                        onClick={() => setIsShowModal(false)}
                        alt="close-icon"
                      />
                    </section>
                    <div className={Styles.locationName}>
                      <h5>{b.name}</h5>
                      <span className={Styles.branch}>
                        {b.branches[showAnotherBranch]}
                      </span>
                      <div className={Styles.divider} />

                      <div className={Styles.address}>
                        <div className={Styles.name}>
                          <img src={iconTitleLocation} alt="icon" />
                          <span
                            className={Styles.linkAddress}
                            onClick={() =>
                              handleOpenGMaps(b.address[showAnotherBranch])
                            }
                          >
                            {b.address[showAnotherBranch]}
                          </span>
                        </div>
                        <div className={Styles.name}>
                          <MdPhone sx={{ color: "#6C757D" }} />
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <span className={Styles.values}>{b.phone[0]}</span>
                            <span className={Styles.values}>{b.phone[1]}</span>
                          </div>
                        </div>
                        <div className={Styles.name}>
                          <Mail sx={{ color: "#6C757D" }} />
                          <span className={Styles.values}>{b.email}</span>
                        </div>
                      </div>
                      {b.branches.length > 1 && (
                        <div className={Styles.buttonIcons}>
                          <div
                            onClick={() =>
                              showAnotherBranch === 0
                                ? {}
                                : setShowAnotherBranch(showAnotherBranch - 1)
                            }
                            className={Styles[showAnotherBranch !== 0]}
                          >
                            <ChevronLeft fontSize="24px" />
                          </div>
                          <div
                            onClick={() =>
                              showAnotherBranch === b.branches.length - 1
                                ? {}
                                : setShowAnotherBranch(showAnotherBranch + 1)
                            }
                            className={
                              Styles[
                                showAnotherBranch === b.branches.length - 1
                              ]
                            }
                          >
                            <ChevronRight fontSize="24px" />
                          </div>
                        </div>
                      )}
                    </div>
                  </section>
                </div>
              </div>
            ))}
        </div>
      </Modal>
      <div ref={aboutRef} id="About Us">
        <div className={Styles.Container}>
          <div className={Styles.left}>
            <div className={Styles.topLeft}>
              <div className={Styles.LeftMap}>
                <img src={mapicon} className={Styles.IconMap} alt="mapicon" />
              </div>
              <span className={Styles.spanYellow}>Our Company Location</span>
              <span className={Styles.spanH1}>
                Our Company is Spread Across Cities in Indonesia
              </span>
            </div>
            <div className={Styles.bottomLeft}>
              {Countries.map((el) => {
                return (
                  <div
                    key={el.id}
                    onClick={() => setIsShowModal(el.name)}
                    className={Styles.countries}
                  >
                    <span>{el.name}</span>
                    <ArrowForward
                      className={`${Styles.chevron}`}
                      sx={{ fontSize: "16px" }}
                    />
                  </div>
                );
              })}
            </div>
          </div>

          <div className={Styles.right}>
            <div className={Styles.globeParent}>
              <img src={IndonesiaGlobe} className={Styles.ImgMap} alt="globe" />

              {permataBranches.map((b) => (
                <TooltipContent b={b} />
              ))}
            </div>
          </div>
        </div>

        <div className={Styles.containerResponsive}>
          <div className={Styles.top}>
            <div className={Styles.companyLocationBox}>
              <div className={Styles.LeftMap}>
                <img src={mapicon} className={Styles.IconMap} alt="mapicon" />
              </div>
              <span className={Styles.spanYellow}>Our Company Location</span>
            </div>
            <span className={Styles.spanH1}>
              Our Company is Spread Across Cities in Indonesia
            </span>
          </div>

          <div className={Styles.imageMap}>
            <img
              src={groupmap}
              className={Styles.imageGroup}
              alt="IndonesiaGlobe"
            />
            <img
              src={IndonesiaGlobe}
              className={Styles.ImgMap}
              alt="IndonesiaGlobe"
            />
          </div>

          <div className={Styles.boxBottom}>
            <div className={`${Styles.bottom}`}>
              {Countries.map((el) => {
                return (
                  <div
                    key={el.id}
                    onClick={() => setIsShowModal(el.name)}
                    className={Styles.countries}
                  >
                    <span>{el.name}</span>
                    {el.name === isShowModal && (
                      <ArrowForward sx={{ fontSize: "16px" }} />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
